import {Component, inject, model, ModelSignal} from '@angular/core';
import {
  CSV_IMPORT_ACTION,
  DEFAULT_TABLE_ACTIONS,
  DialogService,
  ITableAction,
  TableControlComponent,
  TableControlModule,
} from 'frontier/browserkit';
import AppControlGuids from '../../../api/ControlGuids';
import {EControlActions, EsvgFiles} from "frontier";
import {concatMap, Observable, of} from "rxjs";
import {MatDialogRef} from "@angular/material/dialog";
import {
  IRebookRecordsValue,
  RebookRecordsDialogComponent,
} from "./rebook-records-dialog/rebook-records-dialog/rebook-records-dialog.component";
import {ItemPriceMappingService} from "../../../api/generated";
import {tap} from "rxjs/operators";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-item-price-mapping-table',
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  standalone: true,
  imports: [TableControlModule],
})
export class ItemPriceMappingTableComponent extends TableControlComponent {
  private _dialogService: DialogService = inject(DialogService);
  private _itemPriceMappingService: ItemPriceMappingService = inject(ItemPriceMappingService);
  private _snackBar = inject(MatSnackBar);

  override GUID: string = AppControlGuids.TItemPriceMapping;
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    ...DEFAULT_TABLE_ACTIONS,
    CSV_IMPORT_ACTION,
    {
      displayName: 'Umbuchen',
      controlAction: EControlActions.change,
      disabledIfNoSelection: false,
      disabledIfMultiSelection: false,
      color: 'primary',
      icon: EsvgFiles.refresh,
      action: () => this.rebookRecords(),
    },
  ]);

  private rebookRecords(): Observable<boolean> {
    const dialogRef: MatDialogRef<RebookRecordsDialogComponent> = this._dialogService.dialog.open(
      RebookRecordsDialogComponent);
    return dialogRef.afterClosed().pipe(
      concatMap((dialogRes: IRebookRecordsValue | null) => {
        if (!dialogRes) {
          return of(null);
        }
        return this._itemPriceMappingService.itemPriceMappingUpdateReBookingRecords(
          {
            start: dialogRes.fromDate,
            end: dialogRes.toDate,
            rebookall: dialogRes.rebookAll,
          }).pipe(
            tap((res: boolean) => {
              if (res) {
                this._snackBar.open('Umbuchung abgeschlossen.', 'ok',
                  {duration: 3000, verticalPosition: 'top'});
              } else {
                this._snackBar.open('Die Umbuchung war leider nicht erfolgreich.', 'ok',
                  {duration: 3000, verticalPosition: 'top'});
              }
            })
        );
      })
    );
  }
}
